import { useEffect, useState } from "react";
import { Icon } from "@chakra-ui/react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import {
    addItemToWishlist,
    removeItemFromWishlist,
} from "../actions/wishListActions";

const WishlistToggleButton = ({ product, className = "", showLabel = false }) => {
    const dispatch = useDispatch();

    const userInfo = useSelector((state) => state.userLogin.userInfo);
    const wishlistItems = useSelector((state) => state.wishlist.wishlistItems);

    const [isWishlisted, setIsWishlisted] = useState(false);

    const notify = (link, content, type) =>
        type(<RouterLink to={link}>{content}</RouterLink>);

    const addItemToWishlistHandle = (productId) => {
        dispatch(addItemToWishlist(productId));
        notify("/wishlist", "Item Added To Wishlist", toast.success);
    };

    const removeItemFromWishlistHandle = (id) => {
        dispatch(removeItemFromWishlist(id));
        notify("/wishlist", "Item Removed from Wishlist", toast.error);
    };



    useEffect(() => {
        if (userInfo) {
            setIsWishlisted(wishlistItems?.some(item => item._id === product._id));
        } else {
            const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
            setIsWishlisted(localWishlist.some(item => item._id === product._id));
        }
    }, [userInfo, wishlistItems, product._id]);

    const toggleWishlist = () => {
        if (userInfo) {
            if (isWishlisted) {
                removeItemFromWishlistHandle(product._id);
            } else {
                addItemToWishlistHandle(product._id);
            }
        } else {
            const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
            const index = localWishlist.findIndex(item => item._id === product._id);

            if (index > -1) {
                localWishlist.splice(index, 1);
                notify("/wishlist", "Item removed from Wishlist", toast.success);

            } else {
                localWishlist.push(product);
                notify("/wishlist", "Item saved to Wishlist (login to sync)", toast.success);

            }

            localStorage.setItem("savedWishlist", JSON.stringify(localWishlist));

            // Dispatch custom event to notify wishlist updated
            window.dispatchEvent(new Event("localWishlistUpdated"));

            setIsWishlisted(index === -1);
        }
    };

    return (
        <button
            onClick={toggleWishlist}
            className={
                showLabel
                    ? `flex items-center px-3 py-2 bg-gray-100 rounded-md text-sm font-medium text-[#000080] ${className}` : `absolute right-2 z-10 flex items-center text-[#000080] justify-center p-2 bg-white rounded-full shadow ${className}`}
        >
            {showLabel && <span className="mr-2 text-[#000000]">Add to Wishlist</span>}
            <Icon
                as={isWishlisted ? AiFillHeart : AiOutlineHeart}
                w="5"
                h="5"
                className={`${isWishlisted
                    ? "text-[#000080]"
                    : "text-[#000080] animate-twice animate-jump animate-ease-in-out"
                    }`}
                cursor="pointer"
            />
        </button>
    );
};

export default WishlistToggleButton;
